// export const informationNavItems = [
//   "Personal",
//   "Legal",
//   "Financial",
//   "Benefits",
//   "Certification",
//   "Provided Items",
// ];

// export const documentNavItems = [
//   "General",
//   "Training",
//   "Contracts",
//   "Issue/Intake",
//   "Credentials",
//   "Correspondence",
//   "Time-off",
// ];

let language = localStorage.getItem("language");

export const informationNavItems = [
  // "Personal",
  // "Legal",
  // "Financial",
  // "Benefits",
  // "Certification",
  // "Provided Items",

  language === "Dutch" ? "Persoonlijk" : "Personal",
  language === "Dutch" ? "Juridisch" : "Legal",
  language === "Dutch" ? "Financieel" : "Financial",
  language === "Dutch" ? "Voordelen" : "Benefits",
  language === "Dutch" ? "Certificering" : "Certification",
  language === "Dutch" ? "Geleverde artikelen" : "Provided Items",
];

export const documentNavItems = [
  // "General",
  // "Training",
  // "Contracts",
  // "Issue/Intake",
  // "Credentials",
  // "Correspondence",
  // "Time-off",

  language === "Dutch" ? "Algemeen" : "General",
  language === "Dutch" ? "Opleiding" : "Training",
  language === "Dutch" ? "Overeenkomst" : "Contracts",
  language === "Dutch" ? "Uitgifte/inname" : "Issue/Intake",
  language === "Dutch" ? "Referenties" : "Credentials",
  language === "Dutch" ? "Correspondentie" : "Correspondence",
  language === "Dutch" ? "Tijd UIT" : "Time-off",
];
